import script from "./ControlApp2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlApp2.vue?vue&type=script&setup=true&lang=ts"

import "./ControlApp2.vue?vue&type=style&index=0&id=3660c17f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3660c17f"]])

export default __exports__